// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__1RFUy","hidden":"style_hidden__6dQzT"};